import React from "react";
import { PanelEditAdSubCategory } from "../../../UI/AdSubCategories/Edit/PanelEditAdSubCategory";

const EditAdSubCategory = () => {
  return (
    <div>
      <PanelEditAdSubCategory />
    </div>
  );
};

export default EditAdSubCategory;
